export default function skeleton({ variables, }) {
    return {
        MuiSkeleton: {
            styleOverrides: {
                root: {
                    borderRadius: variables.border_radius_small,
                    backgroundColor: variables.surface_subtle,
                },
            },
        },
    };
}
//# sourceMappingURL=skeleton.js.map